import { SettingsScreen } from '../components/settings/parts'
import { NotificationsSettings } from '../components/settings/notifications'

// ============================================================================
// NOTIFICATIONS, ON THE DESKTOP — the settings nav, the header, and the screen.
//
// THE SCREEN ITSELF MOVED to components/settings/notifications.tsx, next to the pieces it is
// built from. This file is now what it always described itself as: the desktop's chrome around it.
//
// WHY IT MOVED. Web Push subscribes THE BROWSER IT IS TURNED ON IN. The switch on this screen
// registers this device and no other, so the setting the desktop cannot possibly change on the
// phone's behalf was, until this commit, reachable only from the desktop — the mobile shell routed
// `/settings/*` to DesktopOnly and there was no entry point at all. mobile/screens/
// NotificationsSettings.tsx now renders THE SAME COMPONENT inside the phone's chrome. Two copies
// would have meant two device lists and two logs, and the second one drifting.
//
// Everything the screen promises — the four honest unavailability states, the log, the fact that
// no control exists without something behind it — is documented where the component lives.
// ============================================================================

export function Notifications() {
  return (
    <SettingsScreen
      active="notifications"
      title="Notifications"
      subtitle="Web Push to this browser — what is sent, to which devices, and what actually arrived"
    >
      <NotificationsSettings />
    </SettingsScreen>
  )
}
